import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A stadium floodlight tower: a tall slim steel mast carrying a wide head frame
// of six floodlights tilted down to wash a pitch or yard with light. The lit
// lenses face +Z.
const MAST = "#878e96";
const MAST_DK = "#6c727a";
const HOUSING = "#5f656b";
const LENS = "#fff0b0";

export const floodlightTower = defineModel({
  id: "floodlight-tower",
  batchId: "electric",
  name: "Floodlight tower",
  tags: ["building", "electric", "power", "lighting", "floodlight"],
  summary: "A tall mast with a head frame of six tilted floodlights.",
  footprint: 0.45,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(0.5, 0.12, 0.5), color: "#5a5a5e", position: [0, 0.06, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.11, 0.3, 10), color: MAST_DK, position: [0, 0.25, 0] },
      // Mast.
      { geometry: new THREE.CylinderGeometry(0.045, 0.07, 2.35, 10), color: MAST, position: [0, 1.45, 0] },
      // Head frame.
      { geometry: new THREE.BoxGeometry(1.0, 0.08, 0.12), color: MAST_DK, position: [0, 2.18, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.08, 0.12), color: MAST_DK, position: [0, 2.52, 0] },
    ];
    // Six floodlights in two clearly separated rows of three.
    const xs = [-0.34, 0, 0.34];
    for (const y of [2.18, 2.52]) for (const x of xs) {
      parts.push({ geometry: new THREE.BoxGeometry(0.26, 0.14, 0.1), color: HOUSING, position: [x, y, 0.12], rotation: [0.35, 0, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.21, 0.1, 0.03), color: LENS, position: [x, y - 0.02, 0.19], rotation: [0.35, 0, 0] });
    }
    return parts;
  },
  animations: [],
});
